export const API_URL = "https://yo-api.parkmate.in/admin";
export const MAIN_API = "https://yo-api.parkmate.in/main";
// export const API_URL = "http://localhost:5007";
// export const MAIN_API = "http://localhost:5000";
